import { useCallback } from 'react';
import { useQueryParam } from '@interlayer/js/app/hooks/useQueryParam';
import { QUERY_PARAMS } from '@interlayer/js/app/hooks/useQueryParam/constants';

export * from '@core/js/components/system/App/hooks/useGetGamesConfiguration/helpers';

export const useGetFeedBlacklist = () => {
    const gameBlacklistFeedName = window.Playtech?.Variables['gameBlacklistFeedName'] || 'Content Roadmap';
    const isShowHiddenGames = useQueryParam(QUERY_PARAMS.showHiddenGames, false);

    return useCallback((gamesFeeds = []) => {
        const blacklistFeed = gamesFeeds.find((feed) => feed.name === gameBlacklistFeedName);

        if (isShowHiddenGames) {
            return [];
        }

        return (blacklistFeed?.categories || [])
            .reduce((gameCodes, category) => gameCodes.concat(category.gameCodes), []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const useFilterFeedBlacklist = () => {
    const getBlacklist = useGetFeedBlacklist();
    const isShowHiddenGames = useQueryParam(QUERY_PARAMS.showHiddenGames, false);

    return useCallback((gameList = [], gamesFeeds) => {
        const blacklist = getBlacklist(gamesFeeds);

        if (isShowHiddenGames) {
            return gameList;
        }

        if (gameList.constructor === Array) {
            return gameList.filter(gameCode => !blacklist.includes(gameCode));
        }

        blacklist.forEach(key => {
            delete gameList[key];
        });

        return gameList;
    }, [getBlacklist, isShowHiddenGames]);
};
